export default __webpack_public_path__ + "static/media/bg-crossing-1.1a50bd3b.svg";